const TRIAL_SUBSCRIPTION_CONVERSION_ID = 'AW-836503333/ZsjeCM6FzJQcEKWO8I4D';
const TRIAL_SUBSCRIPTION_STORAGE_KEY_PREFIX = 'fmz-google-ads-trial-conversion';

type TrialSubscriptionConversionParams = {
  send_to: string;
  transaction_id: string;
};

type GtagFunction = (
  command: 'event',
  eventName: 'conversion',
  params: TrialSubscriptionConversionParams,
) => void;

type TrialSubscriptionConversionContext = {
  redirectStatus: string | null;
  setupIntentId: string | null;
};

type StorageLike = Pick<Storage, 'getItem' | 'setItem'>;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: GtagFunction;
  }
}

function normalizeSetupIntentId(setupIntentId: string | null): string | null {
  if (!setupIntentId) {
    return null;
  }

  const trimmedSetupIntentId = setupIntentId.trim();
  return trimmedSetupIntentId.length > 0 ? trimmedSetupIntentId : null;
}

export function getTrialSubscriptionConversionTransactionId(
  context: TrialSubscriptionConversionContext,
): string | null {
  if (context.redirectStatus !== 'succeeded') {
    return null;
  }

  return normalizeSetupIntentId(context.setupIntentId);
}

export function getTrialSubscriptionConversionStorageKey(transactionId: string): string {
  return `${TRIAL_SUBSCRIPTION_STORAGE_KEY_PREFIX}:${transactionId}`;
}

export function trackTrialSubscriptionConversion(
  storage: StorageLike,
  context: TrialSubscriptionConversionContext,
): boolean {
  const transactionId = getTrialSubscriptionConversionTransactionId(context);

  if (!transactionId) {
    return false;
  }

  const storageKey = getTrialSubscriptionConversionStorageKey(transactionId);
  if (storage.getItem(storageKey) === 'true') {
    return false;
  }

  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return false;
  }

  window.gtag('event', 'conversion', {
    send_to: TRIAL_SUBSCRIPTION_CONVERSION_ID,
    transaction_id: transactionId,
  });
  storage.setItem(storageKey, 'true');

  return true;
}
